import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getEntries() {
    yield* takeEvery("ENTRIES/FETCH", function* (action) {
        try {
            const result = yield call(({ idSeason }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/entries/teamEntryGroup/${idSeason}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { entries, groupings } = result;
                yield put({ type: 'ENTRIES/SET', entries });
                yield put({ type: 'GROUPINGS/SET', groupings });
            } else {
                yield put({
                    type: 'ENTRIES/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'ENTRIES/FETCH_FAILED',
                e
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/entries.js